import { generatePath, useNavigate } from 'react-router-dom';
import AppRoutes from 'src/features/router/data/app-routes';
import { VariantType, useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import useClientApi from 'src/features/clients/hooks/use-client-api';
import FormContainer from './form-container';
import { ErrorStatusCode } from 'src/features/error/ErrorStatusCode';
import { useAppDispatch, useAppSelector } from 'src/redux/hooks';
import { clientsActions, clientsSelectors } from '../../redux/clients-slice';
import { Client } from '../../client-data-types';

const AddClientComponent: React.FC = () => {
    const newClient = useAppSelector(clientsSelectors.newClient);
    const dispatch = useAppDispatch();

    const { addClient } = useClientApi();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    const { t } = useTranslation();

    const updateClient = (client: Client) => {
        dispatch(clientsActions.setNewClient(client));
    };

    const handleAddClient = async () => {
        const addResult = await addClient(newClient!);
        if (addResult.errorStatusCode === null) {
            showMessage(t('clientAdded'), 'success');
            dispatch(
                clientsActions.setNewClient({
                    id: '',
                    hosts: [],
                    favouriteLockerEnabled: false,
                    cui: '',
                } as Client),
            );
            const path = generatePath(AppRoutes.viewClientPath, { clientId: addResult.response! });
            return navigate(path, { state: { from: '/' } });
        } else {
            showMessage(t(ErrorStatusCode[+addResult.errorStatusCode!]), 'error');
        }
    };

    const showMessage = (message: string, variant: VariantType) => {
        enqueueSnackbar(message, {
            variant: variant,
            style: { whiteSpace: 'pre-line' },
        });
    };

    return (
        <FormContainer
            title={t('addClient')}
            client={newClient}
            handleMainActionMethod={handleAddClient}
            bottomButtonText={t('addClient')}
            bottomButtonDisabled={newClient.hosts.length <= 0 || !newClient.cui}
            updateClient={updateClient}
        />
    );
};

export default AddClientComponent;
